import { useEffect, useState } from 'react';
import { useUserQuery } from '../api/query/useAuthQueries';
import { authStore } from '../stores/auth.store';
import { useSnapshot } from 'valtio';

export const useAuthData = () => {
  const [shouldLogout, setShouldLogout] = useState(false);
  const snap = useSnapshot(authStore);

  const {
    data: userData,
    isLoading: isUserLoading,
    isError: isUserError,
    error: userError,
  } = useUserQuery({
    enabled: !!snap.token,
  });

  useEffect(() => {
    if (userData) {
      const user =
        userData?.data?.user ||
        userData?.data ||
        userData?.payload?.user ||
        userData?.payload ||
        userData;
      authStore.setUser(user);
      authStore.setRole(user?.role || null);
    }
  }, [userData]);

  useEffect(() => {
    authStore.setLoading(isUserLoading);
  }, [isUserLoading]);

  useEffect(() => {
    if (isUserError) {
      const message =
        userError?.message ||
        userError?.response?.data?.message ||
        'Failed to load account';

      if (userError?.status === 401 || userError?.response?.status === 401) {
        setShouldLogout(true);
        authStore.reset();
      } else {
        authStore.setError(message);
      }
    } else {
      authStore.setError(null);
    }
  }, [isUserError, userError]);

  return {
    isLoading: isUserLoading,
    isError: isUserError,
    shouldLogout,
  };
};
